import React from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import './RentalCarousel.css';

const banners = [
  {
    type: "image",
    src: "/images/ban1.jpg",
    title: "🚗 Location de véhicules disponible !",
    subtitle: "Réservez facilement dès maintenant.",
  },
  {
    type: "video",
    src: "/videos/location1.mp4",
    title: "🛡️ Assurance & Assistance 24h/24",
    subtitle: "Conduisez l'esprit tranquille avec notre service dédié.",
  },
  {
    type: "image",
    src: "/images/ban3.jpg",
    title: "🔥 Offres Spéciales",
    subtitle: "Des tarifs imbattables pour votre prochain trajet.",
  },
];

export default function RentalCarousel() {
  return (
    <div className="rental-carousel mb-4">
      <Carousel fade interval={5000}>
        {banners.map((item, idx) => (
          <Carousel.Item key={idx} className="position-relative">
            {item.type === "video" ? (
              <video
                className="bg-video w-100 object-fit-cover"
                autoPlay
                muted
                loop
                playsInline
                aria-hidden="true"
              >
                <source src={item.src} type="video/mp4" />
              </video>
            ) : (
              <div
                className="carousel-bg"
                style={{
                  backgroundImage: `url(${item.src})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  filter: "brightness(65%)"
                }}
              ></div>
            )}

            <div className="overlay-content text-white text-center d-flex flex-column justify-content-center align-items-center h-100">
              <h2 className="fw-bold display-5 animate__animated animate__fadeInDown">{item.title}</h2>
              <p className="lead animate__animated animate__fadeInUp">{item.subtitle}</p>
              <Link
                to="/location"
                className="btn btn-light btn-lg mt-3 animate__animated animate__fadeInUp"
              >
                Réserver maintenant
              </Link>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
